<template>
  <div class="project_main">
    <SettingSlider pageName="projectManager" />
    <div class="rightArea">
      <div class="contentArea">
        <div class="add_project" @click="showAdd = true">新增</div>
        <div class="project-area">
          <div class="item" @click="goOverview(item)" v-for="item in dataList" :key="item.id">
            <a-row type="flex">
              <a-col span="10">
                <div class="name">{{ item.name }}</div>
                <div class="year">所属年度：{{ item.year }}</div>
                <div class="time">时限：{{ item.startTime }} -- {{ item.endTime }}</div>
              </a-col>
              <a-col span="8">
                <div class="userSize">上报单位数：{{ item.userSize }}个</div>
                <div class="indexPointSize">指标点总数：{{ item.indexPointSize }}个</div>
                <div class="totalScore">指标总分值：{{ item.totalScore }}分</div>
              </a-col>
              <a-col>
                <div class="actions">
                  <div class="button in" @click.stop="beforeIn(item)">导入指标</div>
                  <div class="button out" @click.stop="excelOut(item)">导出指标</div>
                  <div class="button edit" @click.stop="beforeEdit(item)">编辑</div>

                  <div class="button delete" @click.stop="(showDelete = true), (tempProject = item)">
                    删除
                  </div>
                </div>
              </a-col>
            </a-row>
          </div>
        </div>

        <!-- <div class="add_dialog" v-if="showAdd">
          <div class="add_title">新增项目</div>
          <div class="dialog_item">
            <div class="text">项目名称</div>
            <input type="text" v-model="name" />
          </div>
          <div class="dialog_item">
            <div class="text">起止时间</div>
            <a-range-picker
              class="paper-range"
              v-model="picker"
              :show-time="true"
              format="YYYY-MM-DD HH:mm:ss"
              :placeholder="['开始时间', '结束时间']"
              @change="onTimeChange"
            />
          </div>

          <div class="dialog_item">
            <div class="text">所属年度</div>
            <input type="text" v-model="year" />
          </div>
          <div class="buttons">
            <div class="button add" @click="addProject">确定</div>
            <div class="button cancel" @click="showAdd = false">取消</div>
          </div>
        </div> -->
        <div class="add_dialog" v-if="showEdit">
          <div class="add_title">新增项目</div>
          <div class="dialog_item">
            <div class="text">项目名称</div>
            <input type="text" v-model="name" />
          </div>
          <div class="dialog_item">
            <div class="text">起止时间</div>
            <a-range-picker class="paper-range" v-model="picker" :show-time="true" format="YYYY-MM-DD HH:mm:ss"
              :placeholder="['开始时间', '结束时间']" @change="onTimeChange" />
          </div>

          <div class="dialog_item">
            <div class="text">所属年度</div>
            <input type="text" v-model="year" />
          </div>
          <div class="buttons">
            <div class="button add" @click="editProject">确定</div>
            <div class="button cancel" @click="showEdit = false">取消</div>
          </div>
        </div>

        <div class="excel_in" v-if="showExcelIn">
          <div class="text">选择文件</div>
          <input type="file" @change="pickFile" ref="filePicker" />
          <div class="buttons">
            <div class="button in" @click="pointIn">导入</div>
            <div class="button cancel" @click="showExcelIn = false">取消</div>
          </div>
        </div>

        <!-- Drawer for add -->

        <a-drawer title="新增项目" placement="right" :closable="false" :visible="showAdd" width="600"
          @close="showAdd = false">
          <!-- name: this.name,
          startTime: this.startTime,
          endTime: this.endTime,
          year: this.year, -->
          <a-form-model :model="form" :label-col="{ span: 4 }" :wrapper-col="{ span: 18 }">
            <a-form-model-item label="项目名称">
              <a-input v-model="form.name" />
            </a-form-model-item>
            <a-form-model-item label="所属年度">
              <a-input v-model="form.year" />
            </a-form-model-item>
            <a-form-model-item label="起止时间">
              <a-range-picker v-model="picker" @change="onTimeChange" format="MM-DD" :show-time="true">
                <template slot="dateRender" slot-scope="current">
                  <div class="ant-calendar-date" :style="getCurrentStyle(current)">
                    {{ current.date() }}
                  </div>
                </template>
              </a-range-picker>
            </a-form-model-item>

            <!-- 多选部分绑定的是一个数组 -->
            <a-form-model-item label="审核流程">
              <a-checkbox-group v-model="form.reviewProcess">
                <a-checkbox value="testReview"> 评测员 </a-checkbox>>
                <a-checkbox value="primaryReview"> 初审员 </a-checkbox>>
                <a-checkbox value="finalReview"> 终审员 </a-checkbox>
              </a-checkbox-group>
            </a-form-model-item>
            <a-form-model-item label="评测员选择" v-if="form.reviewProcess">
              <a-checkbox-group class="checkbox_group" v-model="form.testReviewer">
                <a-checkbox v-for="item in testReviewList" :key="item.id" :value="item.id">{{ item.userName }}
                </a-checkbox>
              </a-checkbox-group>
            </a-form-model-item>
            <a-form-model-item label="初审员选择">
              <a-checkbox-group class="checkbox_group" v-model="form.primaryReviewer">
                <a-checkbox v-for="item in primaryReviewList" :key="item.id" :value="item.id">{{ item.userName }}
                </a-checkbox>
              </a-checkbox-group>
            </a-form-model-item>
            <a-form-model-item label="终审员选择">
              <a-checkbox-group class="checkbox_group" v-model="form.finalReviewer">
                <a-checkbox v-for="item in finalReviewList" :key="item.id" :value="item.id">{{ item.userName }}
                </a-checkbox>
              </a-checkbox-group>
            </a-form-model-item>
          </a-form-model>
          <div class="buttons">
            <a-button class="button" @click="showAdd = false">关闭</a-button>
            <a-button class="button" type="primary" @click="addNewProject">确定</a-button>
          </div>
        </a-drawer>

        <!-- Overlay -->
        <a-modal title="警告" :visible="showDelete" @ok="deleteProject(tempProject)" @cancel="showDelete = false">
          确定要删除项目 : {{ tempProject.name }}?
        </a-modal>
      </div>
    </div>
  </div>
</template>
<script>
import SettingSlider from "../../components/SettingSlider.vue";
import server from "../../interface/gradeSys.js";
import baseServer from "../../server";
import storeUtil from "../../utils/storeUtil.js";
import * as dayJs from "dayjs";

export default {
  name: "selfInfo",
  components: {
    SettingSlider: SettingSlider,
  },
  data() {
    return {
      form: {}, // 新建项目表单
      dataList: [],
      showEdit: false,
      showExcelIn: false,
      name: "",
      year: "",
      picker: [],
      startTime: "",
      endTime: "",
      tempItem: {},
      showAdd: false, // 新增项目Drawer
      reviewProcess: [], //审核流程
      testReviewList: [],
      primaryReviewList: [],
      finalReviewList: [],
      tempProject: {}, //点击时缓存当前项目
      showDelete: false, //删除确认
    };
  },
  mounted() {
    this.getProjectList();
    this.getAllReviewer();
  },
  methods: {
    // 查询所有审核人员
    getAllReviewer() {
      server.getAlReviewer().then((result) => {
        console.log(result);
        this.testReviewList = result.filter((item) => {
          return item.roleCode == "testReview";
        });
        this.primaryReviewList = result.filter((item) => {
          return item.roleCode == "primaryReview";
        });
        this.finalReviewList = result.filter((item) => {
          return item.roleCode == "finalReview";
        });
      });
    },
    //导入指标
    beforeIn(item) {
      this.tempItem = item;
      this.showExcelIn = true;
    },
    pickFile() {
      console.log(this.$refs.filePicker.files[0]);
    },
    pointIn() {
      server
        .excelIn({
          file: this.$refs.filePicker.files[0],
          project: this.tempItem.id,
        })
        .then((res) => {
          console.log(res);
          this.showExcelIn = false;
          this.getProjectList();
        });
    },
    // 导出指标
    excelOut(item) {
      console.log("导出指标");
      server
        .exportAll({
          project: item.id,
        })
        .then((res) => {
          console.log(res);
          var target = baseServer.excelUrl + res;
          console.log("target", target);
          window.open(target);
        });
    },
    // 编辑项目
    beforeEdit(item) {
      server.projectDetailV2({ projectID: item.id }).then((result) => {
        this.form = result;
        this.form.reviewProcess = this.string2Array(result.reviewProcess);
        this.form.testReviewer = this.string2Array(result.testReviewer);
        this.form.primaryReviewer = this.string2Array(result.primaryReviewer);
        this.form.finalReviewer = this.string2Array(result.finalReviewer);
      });

      this.tempItem = item;
      // this.showEdit = true;

      this.name = item.name;
      this.year = item.year;
      this.picker[0] = item.startTime;
      this.picker[1] = item.endTime;

      this.startTime = item.startTime;
      this.endTime = item.endTime;

      // 第二版编辑界面
      this.showAdd = true;
    },
    string2Array(str) {
      console.log(str);

      return str.split(",");
    },

    editProject() {
      console.log("编辑项目");
      server
        .editProject({
          id: this.tempItem.id,
          name: this.name,
          startTime: this.startTime,
          endTime: this.endTime,
          year: this.year,
        })
        .then((res) => {
          console.log(res);
          this.showEdit = false;
          this.getProjectList();
        });
    },
    // 删除项目
    deleteProject(item) {
      console.log("删除项目", item);
      server
        .deleteProject({
          projectID: item.id,
        })
        .then((res) => {
          console.log(res);
          this.showDelete = false;
          this.getProjectList();
        });
    },
    // 时间选择器回调
    onTimeChange(dates, dateString) {
      console.log(dates, dateString);
      this.startTime = dateString[0];
      this.endTime = dateString[1];
      this.form.startTime = dateString[0];
      this.form.endTime = dateString[1];
    },

    getCurrentStyle(current) {
      const style = {};
      if (current.date() === 1) {
        style.border = "1px solid #1890ff";
        style.borderRadius = "50%";
      }
      return style;
    },
    // 添加新项目

    beforeAdd() {
      this.name = "";
      this.picker = [];
      this.year = "";
      this.startTime = "";
      this.endTime = "";
      this.showAdd = true;
    },
    addProject() {
      server
        .addProject({
          name: this.name,
          startTime: this.startTime,
          endTime: this.endTime,
          year: this.year,
        })
        .then((res) => {
          console.log(res);
          this.showAdd = false;
          this.getProjectList();
        });
    },
    // 第二版页面的添加项目
    addNewProject() {
      this.form.startTime = dayJs(this.form.startTime).format("YYYY-MM-DD HH:mm:ss");
      this.form.endTime = dayJs(this.form.startTime).format("YYYY-MM-DD HH:mm:ss");

      if (this.form.id) {
        server.editProjectV2(this.form).then(() => {
          this.showAdd = false;
          this.getProjectList();
          this.form = {}
        });
      } else {
        server.addProject(this.form).then(() => {
          this.showAdd = false;
          this.getProjectList();
          this.form = {}
        });
      }
    },
    getProjectList() {
      server
        .projectList()
        .then((result) => {
          this.dataList = [];
          if (result.length && result.length > 0) {
            for (var i = 0; i < result.length; ++i) {
              this.dataList.push({
                id: result[i].id,
                name: result[i].name,
                year: result[i].year,
                startTime: dayJs(result[i].startTime).format("MM-DD"),
                endTime: dayJs(result[i].endTime).format("MM-DD"),
                userSize: result[i].userSize,
                indexPointSize: result[i].indexPointSize,
                totalScore: result[i].totalScore,
              });
            }
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
    goOverview(item) {
      storeUtil.setProject(item);
      this.$router.push({
        path: "/project/overview_admin",
      });
    },
  },
};
</script>
<style scoped lang="less">
.project_main {
  display: flex;
}

.rightArea {
  flex: 1;
  background-color: #f6f9fc;
  border-top: 1px #f6f9fc solid;

  input {
    border-radius: 5px;
    border: 1px solid antiquewhite;
    outline: none;
  }

  .add_dialog {
    background-color: white;
    box-shadow: grey 2px 2px 2px 2px;
    padding: 20px 40px;
    position: absolute;
    top: 20%;
    left: 40%;

    .add_title {
      text-align: center;
      font-size: 18px;
      margin-bottom: 20px;
    }

    .dialog_item {
      margin-bottom: 10px;
      display: flex;

      .text {
        margin-right: 10px;
      }
    }

    .buttons {
      display: flex;
      margin-top: 20px;
      justify-content: space-around;

      .button {
        cursor: pointer;
        width: 30%;
        height: 30px;
        line-height: 30px;
        text-align: center;
        color: white;
        background-color: #4265ed;
        border-radius: 5px;
      }

      .cancel {
        background-color: gray;
      }
    }
  }

  .excel_in {
    top: 20%;
    left: 40%;
    padding: 20px;
    width: 400px;
    position: fixed;
    background-color: white;
    border-radius: 8px;
    box-shadow: gainsboro 3px 3px 3px 3px;

    .text {
      margin: 20px;
      text-align: center;
      font-size: 18px;
      font-weight: 500;
    }

    input {
      margin: 40px;
      width: 80%;
    }

    .buttons {
      margin: 20px;
      display: flex;
      justify-content: space-around;

      .button {
        width: 30%;
        cursor: pointer;
        background-color: #4265ed;
        text-align: center;
        color: white;
        line-height: 30px;
        border-radius: 5px;
        height: 30px;
      }

      .cancel {
        background-color: gainsboro;
      }
    }
  }

  .contentArea {
    height: 888px;
    margin-left: 25px;
    margin-right: 58px;
    margin-top: 48px;

    .add_project {
      width: 200px;
      height: 52px;
      line-height: 52px;
      background: #4265ed;
      opacity: 1;
      border-radius: 3px;
      color: #ffffff;
      font-family: "Source Han Sans CN";
      font-weight: 500;
      font-size: 20px;
      text-align: center;
      cursor: pointer;
      color: white;
      border-radius: 4px;
    }

    .project-area {
      overflow-y: auto;
      height: 788px;

      .item {
        cursor: pointer;
        background-color: white;
        height: 200px;
        margin-top: 38px;
        border-top: 1px #f6f9fc solid;

        .actions {
          display: flex;
          flex-direction: column;
          justify-content: space-around;
          float: right;
          width: 200px;

          .button {
            margin-top: 18px;
            width: 160px;
            background-color: #4265ed;
            border-radius: 4px;
            text-align: center;
            height: 24px;
            line-height: 24px;
            color: white;
          }

          .delete {
            background: #ed4242;
          }
        }

        .name {
          margin-left: 48px;
          margin-top: 30px;
          color: #4265ed;
          font-family: "Source Han Sans CN";
          font-weight: 500;
          font-size: 22px;
        }

        .year {
          margin-left: 48px;
          margin-top: 30px;
          color: #464e58;
          font-family: "Source Han Sans CN";
          font-weight: 500;
          font-size: 17px;
        }

        .time {
          margin-left: 48px;
          margin-top: 30px;
          color: #464e58;
          font-family: "Source Han Sans CN";
          font-weight: 500;
          font-size: 17px;
        }

        .userSize {
          margin-top: 30px;
          color: #464e58;
          font-family: "Source Han Sans CN";
          font-weight: 500;
          font-size: 17px;
        }

        .indexPointSize {
          margin-top: 30px;
          color: #464e58;
          font-family: "Source Han Sans CN";
          font-weight: 500;
          font-size: 17px;
        }

        .totalScore {
          margin-top: 30px;
          color: #464e58;
          font-family: "Source Han Sans CN";
          font-weight: 500;
          font-size: 17px;
        }
      }
    }
  }
}

.buttons {
  margin-top: 40px;
  width: 80%;
  display: flex;
  justify-items: center;
  justify-content: space-evenly;
}

/deep/.ant-drawer-title {
  font-size: 20px !important;
  font-weight: bold !important;
}

.checkbox_group {
  width: 100%;
  line-height: 2;
  padding: 6px;
}

/deep/.ant-form-item-children {
  /deep/.ant-checkbox-wrapper {
    width: 40px;
  }
}
</style>
